import api from '../api'

export const scheduleResource = {
  all () {
    return api().get('/GetSchedules')
  },

  find (id) {
    return api().get(`/GetSchedule/${id}`)
  },

  create (payload) {
    return api().post('/CreateSchedule', payload)
  },

  updateTimeSlots (id, payload) {
    return api().post(`/UpdateScheduleTimeSlots/${id}`, payload)
  }
}
